import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import * as l from "./_csLcl";
import { a } from "./_csAbt";

import * as BoxC from './_ccbBoxC';
import * as BtnC from './_cccBtnC';
import * as BtnCttC from './_ccmBtnCttC';
import * as TblC from "./_ccmTblC";
import * as TextC from "./_ccbTextC";
import * as GridC from './_cccGridC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';

import * as ica from 'src/ica';
import * as ihd from 'src/ihd';

import * as _cv_10 from './_cv_10___Mz';
import * as _cv_41 from './_cv_41___Mz';
import * as _cv_42 from './_cv_42___Mz';

let $_42z = _cv_42.itl_42z();

let $_10rz = {} as ht.dz;
let $_41rs = [] as ht.ls;

export const B = (pz: ht.btnCttCz) => {
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const _42z = await _cv_42.save_42rDzAsync({
            ... pz,
            _42z: $_42z,
          });
          return {
            _10r_key: _42z._42rz._42r_10r1k,
          }
        }
      }
    })
  );
};

export const D = (pz: ht.viewDtlCz) => {

  const _frcUdt = l.frcUdt();

  React.useEffect(() => {

    f.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _frcUdt,
      bfrAsync: () => [
        _cv_41.load_41rLsAsync({
          cdn: pz.cz.cdn,
        })
        .then((_ls: ht.ls) => {
          $_41rs = _ls;
        }),
        _cv_10.load_10rDzAsync({
          _10r_key: pz.sPz.crt._10r_key,
          cdn: 'true',
        })
        .then((_dz: ht.dz) => {
          //hf.l(`_cv_42___Ci 74: ${hf.s(pz.sPz.crt._10r_key)}, ${hf.s(_dz)}`);
          $_10rz = _dz._10rz;
        }),
        _cv_42.load_42rDzAsync({
          _10r_key: pz.sPz.crt._10r_key,
          cdn: 'true',
          vsn: pz.sPz.crt.vsn,
        })
        .then((_dz: ht.dz) => {
          if (hf.f(_dz?._42rz)) {
            $_42z = _dz;
          }
          else {
            _cv_42.crt_42z({
              _10r_key: pz.sPz.crt._10r_key,
            })
            .then((_dz: ht.dz) => {
              $_42z = _dz;
            })
          }
        })
      ],
    });

  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt._10r_key,
    pz.cz.cdn,
    pz.sPz.crt.vsn,
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  const _hdrs = [] as ht.ls;

  _hdrs.push({
    cellCs: [
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
              pfx: '操作を許可する項目'
            }
          })
        ]
      },
    ],
  });

  const _bdys = [] as ht.ls;
  $_42z._421s
  .filter( ( _421z:ht.dz ) => _421z._dlt != 1 )
  .map( ( _421z:ht.dz ) => {
    _bdys.push({
      cellCs: [
        {
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'pcr',
                vle: _421z._421_41r1f ?? -1,
                ls: $_41rs,
                onChg: ( _dz: ht.dz ) => {
                  _421z._421_41r1f = _dz.key;
                }
              }
            })
          ]
        },
        {
          boxStlz: a('dw/10 f/n'),
          oClds: [
            hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnDltCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  _421z._dlt = 1;
                  _frcUdt();
                },
              }
            })
            : null,
          ]
        },
      ],
    });
  });
  
  if ( hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ) {
    _bdys.push({
      cellCs: [
        {
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnAddCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  $_42z._421s.push(ihd.i(`_421`));
                  _frcUdt();
                },
              }
            })
          ]
        },
      ],
    });
  }

  return (
    cr.c(BoxC.N, {
      key: '_42b.Root',
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'nolineCmnz',
          boxStlz: a('dwx/60 mb/2 mh/a'),
          lineCs: [
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `スタッフID`,
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: $_10rz._icn ?? '',
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `スタッフ名`,
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: $_10rz._pfx ?? '',
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
          ]
        }),

        cr.c(TblC.N, {
          key: -20,
          ... _abtz.cldz.tblCz,
          srlCz: {
            srlStlz: {
              otrz: a('dwx/50'),
            }
          },
          hdrCz: {
            lineCs: _hdrs
          },
          bdyCz: {
            lineCs: _bdys
          }
        })

      ]
    })
  );
};

